import React, {useEffect, useState} from 'react'
import {Link, useNavigate, useSearchParams} from "react-router-dom";
import logo from '../assets/images/MGL.png'
import {useForm} from "react-hook-form";
import axios from 'axios';
import {toast} from 'react-toastify';
import {BASE_URL} from "../utils/commonUrl";
import {setAuth} from "../redux/features/auth.feature";
import {useDispatch} from "react-redux";
import {ProgressSpinner} from "primereact/progressspinner";

const Register = () => {
    let navigate = useNavigate();
    const home = useNavigate();
    let dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    // const [credentials, setcredentials] = useState({ empcode: '', officeEmail: '', cellNumber: '', factoryId: '', })

    const [pmsRegister, setRegister] = useState({isLoading: false, message: ''})

    const {register, formState: {errors}, handleSubmit, reset} = useForm();

    const onSubmit = data => {
        //console.log(data);
        userRegister(data);
    }

    useEffect(() => {
     /*   const registerID = searchParams.get("registerID");
       if (registerID === null){
        return navigate("/login")
       }*/

    }, [])


    const notify = (message) => toast.info(message);

    const userRegister = async (body) => {
        const payload = {
            user: {name: '', factory: 'MGL', email: 'anik@bitopibd.com'},
            token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c'
        }
        const registerID = searchParams.get("registerID")
        setRegister({...pmsRegister, isLoading: true})
       // const url = BASE_URL + "/api/register/UpdateRegisterUser"
        const url = BASE_URL + "/api/login/RegisterEmployee"
        try {
            body.email = body.email + "@bitopibd.com"
            body.registerID = registerID
            const response = await axios.post(url, body);
            reset()
            setRegister({...pmsRegister, isLoading: false})

            notify(response.data.message)
            if (response.status === 200) {
                return window.location.href = "/pms/login"
               /* const userResponse = await axios.get(BASE_URL + "/api/Utility/UserProfile/" + registerID);

                if (userResponse.status === 200) {
                    payload.user = userResponse.data[0]
                    payload.user.registerID = registerID
                    dispatch(setAuth(payload));
                    //window.location.reload();
                    return window.location.href = "/"
                }*/
            }
            // reset()
        } catch (e) {
           if (e.response.status === 400){
               notify(e.response.data.message)
           }
           else if (e.response.status === 500){
               notify("Something went wrong Please contact with MIS")
           }
            //console.log("catch->", e.response.data.message)
           // const {message} = e.response.data;
           // notify(message)
            setRegister({...pmsRegister, isLoading: false, message: ''});

        }

    }

    const handleChangeWhiteSpace = (e) => {
        if (e.target.value.includes(" ")) {
          e.target.value = e.target.value.replace(/\s/g, "");
        }
      };


    return (

        <div className='container'>
            <div className='row justify-content-start'>
                <div className='col-md-4  offset-md-4'>
                    <div className='login-logo mt-5 d-flex justify-content-center'>
                        <img src={logo} width="50" height="50" alt={"aaaa"}/>

                        <h1>PMS</h1>
                    </div>
                    <div className='login-logo mt-2 d-flex justify-content-center'>                        
                        <h6>Input Your Information for Register</h6>
                    </div>
                    <form method='POST' className='mt-3' onSubmit={handleSubmit(onSubmit)}>
                        <div className="form-outline mb-3">

                            <select className="form-select" id='factoryID' name='factoryID'
                                    {...register("factoryID", {required: true})}>
                                <option value="">Select Factory Name</option>
                                <option value="02">Corporate/MGL</option>
                                <option value="04">BGL</option>
                                <option value="06">TAL</option>
                                <option value="09">RHL</option>
                            </select>
                            <span
                                className='text-danger'>{errors.factoryID?.type === 'required' && "Please Select a Factory"}</span>
                        </div>

                        <div className="form-outline mb-3">
                            <input type="text" name='employeeCode'
                                   autoComplete="off"
                                   placeholder='Enter Employee Code..'
                                   onKeyUp={handleChangeWhiteSpace}
                                   {...register("employeeCode", {required: true})} id="employeeCode"
                                   className="form-control"/>
                            <span
                                className='text-danger'> {errors.employeeCode?.type === 'required' && "Employee Code is Required"}</span>
                        </div>
                        <div className='email-container mb-3'>
                            <div className="input-group">
                                <input type="text" className="form-control" name='email' placeholder="Enter Email.."
                                       autoComplete="off"
                                       onKeyUp={handleChangeWhiteSpace}
                                       {...register("email", {required: true, maxLength: 30})}

                                       aria-label="Email" aria-describedby="basic-addon2"/>
                                <span className="input-group-text" id="basic-addon2">@bitopibd.com</span><br/>

                            </div>
                            <span
                                className='text-danger'>{errors.email?.type === 'required' && "Email is Required"}</span>
                        </div>


                        <div className="form-outline mb-3">
                            <input type="phone" name='contactNo'
                                   placeholder='Enter Cell Number..'
                                   {...register("contactNo", {required: true, maxLength: 20})} id="contactNo"
                                   onKeyUp={handleChangeWhiteSpace}
                                   autoComplete="off"
                                   className="form-control"/>
                            <span
                                className='text-danger'>{errors.contactNo?.type === 'required' && "Cell Number is Required"}</span>
                        </div>


                        <div className="form-outline mb-3">
                            <input type="text" name='userName' pattern="[^\s]+"
                                   placeholder='Enter username..'
                                   {...register("userName", {required: true, maxLength: 12})} id="userName"
                                   autoComplete="off" onKeyUp={handleChangeWhiteSpace}
                                   className="form-control"/>
                            <span
                                className='text-danger'>{errors.userName?.type === 'required' && "userName is Required"}</span>
                        </div>

                        <div className="form-outline mb-3">
                            <input type="password" name='password'
                                placeholder='Password' onKeyUp={handleChangeWhiteSpace}
                                {...register("password", { required: true, maxLength: 20 })} id="password"
                                autoComplete="off"
                                className="form-control" />
                            <span className='text-danger'>{errors.password?.type === 'required' && "Password is required"}</span>
                        </div>

                        <div className='d-flex justify-content-between'>
                            <button type="submit" className="btn btn-primary btn-block mb-4 mt-2" disabled={pmsRegister.isLoading}>
                                <i className="bi bi-chevron-double-right"/> Submit
                            </button>
                            <Link className="m-2" to={"/login"}><i class="bi bi-unlock-fill"></i> Already a User? Login</Link>
                            {pmsRegister.isLoading ? <ProgressSpinner style={{height:'40px',width:'40px'}} />:""}
                        </div>
                        {/* <p>Already have an Account? <Link to="/login" className='text-danger'
                                                          style={{textDecoration: 'none'}}>Login</Link></p> */}


                    </form>
                </div>
            </div>
            {/* 
            <form onSubmit={handleSubmit(onSubmit)}>
      <input {...register("firstName", { required: true, maxLength: 20 })} />
        {errors.firstName?.type === 'required' && "First name is required"}
      <input {...register("lastName", { pattern: /^[A-Za-z]+$/i })} />
      <input type="number" {...register("age", { min: 18, max: 99 })} />
      <input type="submit" />
    </form> */}

        </div>
    )
}

export default Register